import type { TFunction } from 'i18next';

const SLUG_TO_I18N_KEY: Record<string, string> = {
  'mbti-oejts-1.2': 'mbti',
  'disc-v1.0': 'disc',
};

export type JobTFunction = TFunction<'job'>;

type PsychometricTestCopyKey =
  | 'exam_config.library.tests.mbti.name'
  | 'exam_config.library.tests.mbti.description'
  | 'exam_config.library.tests.disc.name'
  | 'exam_config.library.tests.disc.description';

function testCopyKey(slug: string, field: 'name' | 'description'): PsychometricTestCopyKey | null {
  const key = SLUG_TO_I18N_KEY[slug];
  if (!key) return null;
  return `exam_config.library.tests.${key}.${field}` as PsychometricTestCopyKey;
}

function translateJobKey(t: JobTFunction, key: PsychometricTestCopyKey): string {
  // Runtime key is built from slug; cast matches tForContent pattern in utils/locale.ts.
  return t(key as never) as string;
}

export function resolvePsychometricTestName(
  slug: string,
  fallback: string,
  t: JobTFunction,
): string {
  const i18nKey = testCopyKey(slug, 'name');
  if (!i18nKey) return fallback;
  const translated = translateJobKey(t, i18nKey);
  return translated === i18nKey ? fallback : translated;
}

export function resolvePsychometricTestDescription(
  slug: string,
  fallback: string | null | undefined,
  t: JobTFunction,
): string | null {
  const i18nKey = testCopyKey(slug, 'description');
  if (!i18nKey) return fallback?.trim() || null;
  const translated = translateJobKey(t, i18nKey);
  if (translated === i18nKey) {
    return fallback?.trim() || null;
  }
  return translated;
}
